var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg87(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81875 6.31875C6.81875 6.46875 6.76875 6.59375 6.66875 6.71875L1.01875 12.4688C0.793751 12.6938 0.443751 12.6938 0.218751 12.4688C-0.00624928 12.2438 -0.0062493 11.8938 0.218751 11.6688L5.44375 6.31875L0.16875 0.968749C-0.05625 0.743749 -0.05625 0.39375 0.16875 0.16875C0.39375 -0.0562499 0.74375 -0.0562499 0.96875 0.16875L6.61875 5.91875C6.74375 6.04375 6.81875 6.16875 6.81875 6.31875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg87);
export default __webpack_public_path__ + "static/media/svg87.ba18f2aaf65f9199923617a8b7d61dab.svg";
export { ForwardRef as ReactComponent };